import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  PopoverBody,
  PopoverHeader,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import CollectionsBreadcrumbs from '../Collections/Breadcrumbs';
import LoadingSmall from '../LoadingSmall';

const FileCollections = ({
  profile,
  file,
  collections,
  loading,
  personal,
}) => {
  const intl = useIntl();

  let allCollections = collections;
  if (profile && profile.is_admin) {
    if (personal) {
      allCollections = collections.filter(c => (c.my));
      if (allCollections.length === 0) {
        return null;
      }
    } else {
      allCollections = collections.filter(c => (!c.my));
    }
  } else if (personal) {
    return null;
  }

  const getLinkTo = (collection) => {
    if (collection.archived) {
      return `/archive/collections/${collection.uuid}`;
    }
    if (collection.deleted_at) {
      return `/trash/collections/${collection.uuid}`;
    }
    return `/collections/${collection.uuid}`;
  };

  return (
    <>
      <PopoverHeader>
        {personal ?
          intl.formatMessage({ defaultMessage: `Users' My Collections` }) :
          intl.formatMessage({ defaultMessage: 'Collections' })}
      </PopoverHeader>
      <PopoverBody>
        {collections.length > 0 ? (
          <ul className="file-collections-list">
            {allCollections.map(collection => (
              <Fragment key={collection.uuid}>
                <Link
                  id={`collection-my-${collection.uuid}`}
                  to={getLinkTo(collection)}
                  target="_blank"
                  onClick={(e) => e.stopPropagation()}
                >
                  <li>
                    <CollectionsBreadcrumbs collection={collection} inSearch={true} />
                    <span className="file-collections-list-name">
                      {collection.name}
                    </span>
                    {(personal && collection.user) && (
                      <span className="file-collections-list-user">
                        ({collection.user.name})
                      </span>
                    )}
                  </li>
                </Link>
              </Fragment>
            ))}
          </ul>
        ) : (
          <span>
            {loading ? (
              <LoadingSmall />
            ) : (
              <span>
                {file.type === 'link' ?
                  intl.formatMessage({ defaultMessage: `Link doesn't belong to any Collection` }) :
                  intl.formatMessage({ defaultMessage: `File doesn't belong to any Collection` })}
              </span>
            )}
          </span>
        )}
      </PopoverBody>
    </>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
});

FileCollections.propTypes = {
  profile: PropTypes.object.isRequired,
  file: PropTypes.object.isRequired,
  collections: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  personal: PropTypes.bool,
};

FileCollections.defaultProps = {
  personal: false,
};

export default connect(mapStateToProps)(FileCollections);
